const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");

const ForgottenOrganizationsActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

ForgottenOrganizationsActions.fetchData.listen(function(users) {
  let params = {
    users: users
  };

  biAPI.fetch("/forgotten_organizations", params, this.completed, this.failed);
});

module.exports = ForgottenOrganizationsActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/forgotten-organizations-actions.js